const FILTER_CLASSES = ['energy', 'sleep', 'mood', 'stress', 'focus', 'other'];

function getFilterKey(item) {
  return FILTER_CLASSES.find((c) => item.classList.contains(c));
}

function toggleFilter(filterItems, clearButton, filterDisclaimer) {
  filterItems.forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('active');
      toggleFilterButtons(clearButton, filterItems, filterDisclaimer);
      filterStudies(filterItems);
      updateQueryParams(filterItems);
    });
  });
}

function toggleFilterButtons(clearButton, filterItems, filterDisclaimer) {
  const anyActive = Array.from(filterItems).some((i) => i.classList.contains('active'));
  const isMobile = window.innerWidth <= 768;
  if (anyActive) {
    clearButton.forEach((button) => {
      if (isMobile && button.classList.contains('desktop')) {
        button.style.display = 'none';
      } else if (!isMobile && button.classList.contains('mobile')) {
        button.style.display = 'none';
      } else {
        button.style.display = 'flex';
      }
    });
    filterDisclaimer.forEach((disclaimer) => {
      disclaimer.style.display = 'none';
    });
  } else {
    clearButton.forEach((button) => {
      button.style.display = 'none';
    });
    filterDisclaimer.forEach((disclaimer) => {
      if (isMobile && disclaimer.classList.contains('desktop')) {
        disclaimer.style.display = 'none';
      } else if (!isMobile && disclaimer.classList.contains('mobile')) {
        disclaimer.style.display = 'none';
      } else {
        disclaimer.style.display = 'block';
      }
    });
  }
}

function toggleIcons(item, activeFilters) {
  const icons = item.querySelectorAll('.research-studies-item-icon');

  icons.forEach((icon) => {
    const iconType = icon.dataset.studyType;
    const isActive = activeFilters.length !== 0 && activeFilters.includes(iconType);

    const src = icon.getAttribute('src');

    if (isActive) {
      icon.classList.add('active');

      if (!src.includes('_active')) {
        const newSrc = src.replace(/(\.svg)/, '_active$1');
        icon.setAttribute('src', newSrc);
      }
    } else {
      icon.classList.remove('active');

      if (src.includes('_active')) {
        const newSrc = src.replace('_active.svg', '.svg');
        icon.setAttribute('src', newSrc);
      }
    }
  });
}

function showStudiesCount(count) {
  const spanElements = document.querySelectorAll('.research-studies-filter-clear span');
  if (!spanElements && spanElements.length === 0) return;
  spanElements.forEach((span) => {
    let buttonText = span.innerHTML;
    buttonText = buttonText.replace(/\b\d{1,2}\b/, count);
    span.innerHTML = buttonText;
  });
}

function filterStudies(filterItems) {
  const activeFilters = Array.from(filterItems)
    .filter((i) => i.classList.contains('active'))
    .map((i) => getFilterKey(i));

  const studyItems = Array.from(document.querySelectorAll('.research-studies-item'));
  let activeStudiesCounter = 0;

  // Filtering studies
  studyItems.forEach((item) => {
    const studyTypes = item.dataset.studyType.trim().split(/\s+/);

    if (activeFilters.length === 0 || activeFilters.some((f) => studyTypes.includes(f))) {
      item.classList.add('active');
      activeStudiesCounter++;
    } else {
      item.classList.remove('active');
    }
    toggleIcons(item, activeFilters);
  });

  // Sorting if there are active filters
  studyItems.sort((a, b) => {
    if (activeFilters.length === 0) {
      const yearA = parseInt(a.dataset.studyYear || 0, 10);
      const yearB = parseInt(b.dataset.studyYear || 0, 10);
      return yearB - yearA;
    }

    const aTypes = a.dataset.studyType.trim().split(/\s+/);
    const bTypes = b.dataset.studyType.trim().split(/\s+/);
    const aMajors = a.dataset.studyTypeMajor.trim().split(/\s+/);
    const bMajors = b.dataset.studyTypeMajor.trim().split(/\s+/);

    const aIsMajorStudy = a.dataset.majorStudy === 'true';
    const bIsMajorStudy = b.dataset.majorStudy === 'true';

    const aHasMajorFilter = activeFilters.some((f) => aMajors.includes(f));
    const bHasMajorFilter = activeFilters.some((f) => bMajors.includes(f));
    const aHasMinorFilter = activeFilters.some((f) => aTypes.includes(f) && !aMajors.includes(f));
    const bHasMinorFilter = activeFilters.some((f) => bTypes.includes(f) && !bMajors.includes(f));

    const getRank = (isMajorStudy, hasMajorFilter, hasMinorFilter) => {
      if (hasMajorFilter && isMajorStudy) return 0;
      if (hasMinorFilter && isMajorStudy) return 1;
      if (hasMajorFilter && !isMajorStudy) return 2;
      if (hasMinorFilter && !isMajorStudy) return 3;
      return 4;
    };

    const rankA = getRank(aIsMajorStudy, aHasMajorFilter, aHasMinorFilter);
    const rankB = getRank(bIsMajorStudy, bHasMajorFilter, bHasMinorFilter);

    if (rankA !== rankB) return rankA - rankB;

    const yearA = parseInt(a.dataset.studyYear || 0, 10);
    const yearB = parseInt(b.dataset.studyYear || 0, 10);

    return yearB - yearA; // New → old
  });

  // Mounting sorted items to container
  const container = document.querySelector('.research-studies-list');
  studyItems.forEach((item) => container.appendChild(item));

  // Showing studies count
  showStudiesCount(activeStudiesCounter);

  window.visibleCount = 4;
  updateStudiesVisibility();
}

function updateQueryParams(filterItems) {
  const activeFilters = Array.from(filterItems)
    .filter((i) => i.classList.contains('active'))
    .map((i) => getFilterKey(i));

  const query = activeFilters.length ? `?filters=${activeFilters.join(',')}` : '';
  window.history.replaceState(null, '', window.location.pathname + query);
}

function applyFiltersFromQuery(filterItems) {
  const params = new URLSearchParams(window.location.search);
  const filters = params.get('filters');
  if (!filters) return;

  const activeKeys = filters.split(',');

  filterItems.forEach((item) => {
    const key = getFilterKey(item);
    if (activeKeys.includes(key)) {
      item.classList.add('active');
    }
  });
}

function initFiltering() {
  const filterItems = document.querySelectorAll('.research-studies-filter-item');
  const clearButton = document.querySelectorAll('.research-studies-filter-clear');
  const filterDisclaimer = document.querySelectorAll('.research-studies-disclaimer');

  clearButton.forEach((button) => {
    button.addEventListener('click', () => {
      window.visibleCount = 4;
      filterItems.forEach((item) => item.classList.remove('active'));
      toggleFilterButtons(clearButton, filterItems, filterDisclaimer);
      filterStudies(filterItems);
      updateQueryParams(filterItems);
      updateStudiesVisibility();
    });
  });

  applyFiltersFromQuery(filterItems);
  toggleFilterButtons(clearButton, filterItems, filterDisclaimer);
  filterStudies(filterItems);
  toggleFilter(filterItems, clearButton, filterDisclaimer);
}

function updateStudiesVisibility() {
  const items = document.querySelectorAll('.research-studies-item.active');
  const showMoreBtn = document.getElementById('show-more-studies');

  // Скрываем все
  document.querySelectorAll('.research-studies-item').forEach((item) => {
    item.style.display = 'none';
  });

  // Показываем только нужное количество
  items.forEach((item, index) => {
    if (index < window.visibleCount) item.style.display = 'flex';
  });

  // Кнопка "Show more"
  if (items.length > window.visibleCount) {
    showMoreBtn.style.display = 'block';
  } else {
    showMoreBtn.style.display = 'none';
  }
}

function sortIconsByMajor() {
  const iconContainers = document.querySelectorAll('.research-studies-icon-container');

  iconContainers.forEach((container) => {
    const icons = Array.from(container.querySelectorAll('.research-studies-item-icon'));

    icons.sort((a, b) => {
      const aMajor = a.classList.contains('major');
      const bMajor = b.classList.contains('major');

      if (aMajor && !bMajor) return -1;
      if (!aMajor && bMajor) return 1;

      return 0;
    });
    icons.forEach((icon) => container.appendChild(icon));
  });
}

function initShowMoreStudies() {
  const showMoreBtn = document.getElementById('show-more-studies');
  if (!showMoreBtn) return;

  window.visibleCount = 4;

  showMoreBtn.addEventListener('click', () => {
    window.visibleCount += 4;
    updateStudiesVisibility();
  });
}

function initExpandStudyButtons() {
  const expandButtons = document.querySelectorAll('.research-studies-item-expand');
  const allStudyItems = document.querySelectorAll('.research-studies-item');
  const switchContainer = document.querySelector('.research-studies-pro-switch');
  const goTopButton = document.querySelector('.scroll-top-button');

  expandButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const studyItem = button.closest('.research-studies-item');
      const primaryExpandBtn = studyItem.querySelector('.research-studies-item-expand:not(.collapse)');
      const isAlreadyExpanded = studyItem.classList.contains('expanded');

      if (isAlreadyExpanded) {
        studyItem.classList.remove('expanded');
        if (switchContainer) switchContainer.classList.remove('active');
        if (goTopButton) goTopButton.classList.remove('switch');
        if (window.innerWidth > 768 && primaryExpandBtn) {
          primaryExpandBtn.style.display = '';
        }
        return;
      }

      allStudyItems.forEach((item) => {
        if (item !== button.closest('.research-studies-item')) {
          item.classList.remove('expanded');
          if (goTopButton) goTopButton.classList.remove('switch');
          const expandBtn = item.querySelector('.research-studies-item-expand:not(.collapse)');
          if (expandBtn) expandBtn.style.display = '';
        }
      });

      studyItem.classList.add('expanded');
      if (window.innerWidth > 768 && primaryExpandBtn) {
        primaryExpandBtn.style.display = 'none';
      }
      if (switchContainer) switchContainer.classList.add('active');
      if (goTopButton) goTopButton.classList.add('switch');

      const yOffset = -120;
      const y = studyItem.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });
    });
  });
}

function SwitchProMode(switchContainer) {
  const proImages = document.querySelectorAll('.research-studies-item-studie-image.pro');
  const standardImages = document.querySelectorAll('.research-studies-item-studie-image.standard');

  const proDescriptions = document.querySelectorAll('.research-studies-item-description-container.pro');
  const standardDescriptions = document.querySelectorAll('.research-studies-item-description-container.standart');

  const isProMode = switchContainer.querySelector('.research-studies-pro-switch-toggle').classList.contains('active');
  const standartSwitchText = switchContainer.querySelectorAll('.research-studies-pro-switch-text.standart');
  const proSwitchText = switchContainer.querySelector('.research-studies-pro-switch-text.pro');

  if (isProMode) {
    standartSwitchText.forEach((switchText) => {
      switchText.style.display = 'none';
    });
    proSwitchText.style.display = 'block';
    proDescriptions.forEach((desc) => {
      desc.style.display = 'flex';
    });
    standardDescriptions.forEach((desc) => {
      desc.style.display = 'none';
    });
    proImages.forEach((img) => {
      img.classList.add('active');
    });
    standardImages.forEach((img) => {
      img.style.display = 'none';
    });
  } else {
    standartSwitchText.forEach((switchText) => {
      switchText.style.display = '';
    });
    proSwitchText.style.display = 'none';
    proDescriptions.forEach((desc) => {
      desc.style.display = 'none';
    });
    standardDescriptions.forEach((desc) => {
      desc.style.display = 'flex';
    });
    proImages.forEach((img) => {
      img.classList.remove('active');
    });
    standardImages.forEach((img) => {
      img.style.display = '';
    });
  }
}

function initButtonsSwitchProMode() {
  const switchContainer = document.querySelector('.research-studies-pro-switch');
  if (!switchContainer) return;

  switchContainer.querySelector('.research-studies-pro-switch-button-close').addEventListener('click', () => {
    switchContainer.style.display = 'none';
  });

  const toggle = switchContainer.querySelector('.research-studies-pro-switch-toggle');
  toggle.addEventListener('click', () => {
    toggle.classList.toggle('active');
    SwitchProMode(switchContainer);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initFiltering();
  initShowMoreStudies();
  updateStudiesVisibility();
  sortIconsByMajor();
  initExpandStudyButtons();
  initButtonsSwitchProMode();
});
